import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  updateRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '98%',
    minWidth: 0,
  },
  recipientFieldsGrid: {
    display: 'grid',
    flex: 1,
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box',
    gap: theme.spacing(3),
    gridTemplateColumns:
      'minmax(0, 21fr) minmax(0, 21fr) minmax(0, 21fr) minmax(0, 32fr)',
    alignItems: 'start',
  },
  fieldCell: {
    minWidth: 0,
    width: '100%',
    boxSizing: 'border-box',
  },
  recipientsRowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
  deleteWrapper: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addRecipientBtn: {
    color: theme.palette.select.light,
    cursor: 'pointer',
    fontWeight: 500,
    width: 'fit-content',
    marginTop: theme.spacing(2),
  },
  removeIconPadding: {
    padding: theme.spacing(0),
    height: '32px',
    width: '32px',
  },
}))
